import { render, staticRenderFns } from "./JobPostingAutoDisplay.vue?vue&type=template&id=59ccb851&scoped=true&"
import script from "./JobPostingAutoDisplay.vue?vue&type=script&lang=js&"
export * from "./JobPostingAutoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./JobPostingAutoDisplay.vue?vue&type=style&index=0&id=59ccb851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ccb851",
  null
  
)

export default component.exports